import { takeLatest, call, put } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { NotificationAction } from "../actions";
import * as notificationApi from "../api/notification";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

export function* watcherNotifications() {
  yield takeLatest(types.NOTIFICATION_LIST_REQUEST, worker);
  yield takeLatest(types.NOTIFICATION_READ_REQUEST, readWorker);
}

function fetchNotifies(sort = null) {
  return notificationApi.get(sort);
}

function* worker(action) {
  try {
    const response = yield call(fetchNotifies, action.sort);
    yield put(NotificationAction.getListSuccess(response.data.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(NotificationAction.getListFailure(error));
  }
}

function readNotification(id) {
  return notificationApi.read(id);
}

function* readWorker(action) {
  try {
    yield call(readNotification, action.id);
  } catch (error) {}
}
